<template>
    <div class="pt-24">

<div class="container px-3 mx-auto items-center text-white">

<div class="text-center">
 <h1 class="mb-10 my-4 text-5xl font-bold leading-tight ">
            Acerca de GeoDir
          </h1>
</div>


<p class="mb-4">Su nombre proviene del acrónimo (Geographic - Geográfica y Directions - Tendencia o rumbo). Geographic Directions, empresa especializada en software e información geográfica.</p>
<p class="mb-4">GeoDir es una empresa creada para brindar servicios y soluciones de software e información geográfica y localización, cuenta con una plataforma en la nube (cloud computing) que provee herramientas de mapeo para desarrolladores y usuarios.</p>
<p class="mb-4">GeoDir es una empresa Open Source, construimos nuestros productos con partes de Open Source y liberamos parte de nuestro código.</p>
<p class="mb-4">Fue creada en Junio del 2016 cuenta con 2 productos: GeoDir Geocoder y GeoDir Builder.</p>
<p class="mb-4">Tambien ofrece servicios gratuitos a la sociedad como son: Recursos Geográficos, Galeria de Mapas y Guia de Calles.</p>
<p class="mb-4">Si tu negocio es una empresa multinacional, un fabricante local o una sola tienda, sabemos que la innovación  es la clave del éxito, tanto en el producto que fabrica, como en la estrategia comercial de sus productos e ideas. Es por eso que seguimos desarrollando mejores soluciones, para ayudarte a satisfacer las necesidades de los consumidores de hoy en día, y no solo eso, también para investigar hacia dónde se dirigen las tendencias.</p> 

</div>




        

    </div>
</template>
<script>

export default {
    components:{
        
    },
    data(){
        return{
            tokenValue: '',
        }
    },
    created(){

        console.log('obtener token');

        let token = JSON.parse(window.localStorage.getItem("geodir_Token"));
        //_geo.setAccessToken(token.data.access_token);
        //app.access_token= token.data.access_token;
        console.log(token);
        this.tokenValue = token.data.access_token;

    },
    methods:{

    },

}
</script>
<style scoped>

</style>